import type { UserProfile } from './models/user';

export const IFRAME_MESSAGE_TYPE = 'yoop-iframe';
export const IFRAME_PORT_ORIGIN_PARAM = 'portOrigin';
export const IFRAME_AUTH_TOKEN_PARAM = 'yoop-auth-token';
export const IFRAME_ORIGIN_PARAM = 'iframeOrigin';
export const WAIT_FOR_AUTH_PARAM = 'waitForAuth';
export const IFRAME_CLOSE_MSG = 'iframe-on-close';
export const ANALYTICS_EVENT = 'analytics-event';
export const IFRAME_INIT_EVENT = 'init';
export const IFRAME_INVALID_ORIGIN = 'invalid-iframe-origin';

export enum YoopIframeOrigin {
  Login = 'login',
  Transaction = 'transaction',
  MyYoop = 'myYoop',
  CommsManager = 'commsManager',
}

export interface IframeMessageType<T = any> {
  type: string;
  origin: YoopIframeOrigin;
  content?: T;
}

//Represents the types of actions a whitelabel client can trigger on our iframe content
export enum YoopIframeMessageAction {
  UpdateConfig = 'updateConfig',
  VerifyGoogleToken = 'verifyGoogleToken',
  VerifyAppleToken = 'verifyAppleToken',
  ConfigureOAuth = 'configureOAuth',
  Authenticated = 'authenticated',
  AuthenticationRequested = 'authenticationRequested',
  AuthInit = 'authInit',
  LogoutRequested = 'logoutRequested',
  LogoutUser = 'logoutUser',
}

export interface PortMessage<T = any, A = string> {
  action: A;
  key: string;
  data?: T;
}

export type InitialAuthData =
  | {
      isLoggedIn: true;
      authToken: string;
      profile: UserProfile;
    }
  | { isLoggedIn: false };

export interface AuthenticationRequestedData {
  email?: string;
  emailVerificationToken?: string;
  authSource?: string;
  preferredAuthStep?: string;
}
